import { Card, Descriptions } from 'antd';
import React, { memo } from 'react';

/**
 * Component for displaying applicant academic information
 * @param {Object} props - Component props
 * @param {Object} props.data - Applicant data object
 */
const AcademicInfo = memo(({ data }) => {
    if (!data) return null;

    return (
        <Card className="mb-4">
            <Descriptions title="Academic Information" bordered column={{ xxl: 3, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}>
                <Descriptions.Item label="Academic Level">{data.academicLevel}</Descriptions.Item>
                <Descriptions.Item label="Academic Strand">{data.academicStrand}</Descriptions.Item>
                <Descriptions.Item label="Academic Year">{data.academicYear || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Academic Term">{data.academicTerm || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Student ID">{data.studentID || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Applicant ID">{data.applicantID || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="LRN Number">{data.lrnNo || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Entry Level">{data.entryLevel || 'N/A'}</Descriptions.Item>
            </Descriptions>

            {data.elementarySchoolName && (
                <div className="mt-4">
                    <Descriptions title="Elementary Education" bordered column={{ xxl: 3, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}>
                        <Descriptions.Item label="School Name">{data.elementarySchoolName}</Descriptions.Item>
                        <Descriptions.Item label="Last Year Attended">{data.elementaryLastYearAttended || 'N/A'}</Descriptions.Item>
                        <Descriptions.Item label="Remarks/Highest Achievement">{data.elementaryRemarks || 'N/A'}</Descriptions.Item>
                    </Descriptions>
                </div>
            )}

            {data.juniorHighSchoolName && (
                <div className="mt-4">
                    <Descriptions title="Junior High School Education" bordered column={{ xxl: 3, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}>
                        <Descriptions.Item label="School Name">{data.juniorHighSchoolName}</Descriptions.Item>
                        <Descriptions.Item label="Last Year Attended">{data.juniorHighLastYearAttended || 'N/A'}</Descriptions.Item>
                        <Descriptions.Item label="Remarks/Highest Achievement">{data.juniorHighRemarks || 'N/A'}</Descriptions.Item>
                    </Descriptions>
                </div>
            )}
        </Card>
    );
});

export default AcademicInfo;